<div class="dashboard-multi-gauge-graph-per-row">
    <div class="dashboard-body-shared" *ngIf="data">
        <div class="dashboard-multi-gauge-graph-tile-header">
            <div class="card-header-no-bg">
                {{ data.dashboardTileName }}
            </div>
            <div *ngIf="data.lastUpdate" class="dashboard-multi-gauge-graph-last-update">Updated: {{data.lastUpdate | date : 'M/d/yy h:mm a'}}</div>
        </div>
        <div *ngIf="data.summary">
            <div class="dashboard-multi-gauge-graph-per-row-charts" *ngIf="data.summary?.countItems?.length > 0; else showDefault">
                <div class="enrollments-happening-charts-col dashboard-multi-gauge-graph-per-row-charts-column"
                     *ngFor="let dataItem of data.summary.countItems">
                    <div>
                        <app-dashboard-gauge-chart [data]="dataItem"
                                                    [totalRecords]="data.summary.totalRecords">
                        </app-dashboard-gauge-chart>
                        <div class="dashboard-multi-gauge-graph-per-row-charts-footer">
                            <span class="dashboard-multi-gauge-graph-per-row-charts-item-count">{{ dataItem.itemCount | number }}</span>
                            <span> / {{ data.summary.totalRecords | number }}</span>
                        </div>
                    </div>
                    <app-dashboard-actions [tile]="data" 
                                           [item]="dataItem"
                                           [divider]="true">
                    </app-dashboard-actions>
                </div>
            </div>
            <ng-template #showDefault>
                <div class="dashboard-multi-gauge-graph-per-row-default-text">
                    {{ data.summary?.defaultDisplayText }}
                </div>
            </ng-template>
        </div>
        <app-dashboard-tile-loading *ngIf="!data.summary"></app-dashboard-tile-loading>
    </div>
</div>

